<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
/**
 *  @file: App.vue is a <vue> file
 *  @date: File created 2020-11-09 21:05
 *  @author:  shangwenhe
 */
import { fetchUserInfo } from './service/api'
import { init as initApm } from '@elastic/apm-rum'
import loadScript from './uitl/load-script';
export default {
  name: 'App',
  components: {
  },
  created() {
    this.saLogin();
    const h = document.querySelector("html")
    window.env = h.getAttribute('env') || 'test'
  },
  methods: {
    saLogin() {
      fetchUserInfo().then(res => {
        if(res.state == 1) {
          let { id } = res.content;
          if (id) {
              window.sa && window.sa.login(id);
              lgSa.lgSaRegister({
                user_id: id
              })
          } else {
              let first_id = window.sa && window.sa.store && window.sa.store.getFirstId();
              window.sa && first_id && window.sa.logout(true);
          }
        }
      }).catch(error => {
        console.log(error);
      });
    },
  },
  mounted(){
    loadScript('https://res.wx.qq.com/open/js/jweixin-1.3.2.js');
    const currentPage = window.location.pathname || window.location.href.split('#/')[1];
    // console.log("pageLoadTransactionName", currentPage)
    const apm = initApm({
      serviceName: 'growth-sem',
      serverUrl: 'https://appsa.lagou.com',
      serviceVersion: '7.2.7',
      environment: window.env,
      logLevel: 'trace',
      pageLoadTransactionName: currentPage,
      disableInstrumentations: ['error']
      // distributedTracingOrigins: [
      //   /https?:\/\/s2[01]\.lgstatic\.com/,
      //   /https?:\/\/.*\.lagou.com/,
      // ],
    })
    if (window.userInfo) {
      apm.setUserContext({
        username: window.userInfo.nickName,
        id: window.userInfo.id,
      });
    }
    window.addEventListener('error', function (event) {
      let target = event.target || event.srcElement;
      let isElementTarget = target instanceof HTMLScriptElement || target instanceof HTMLLinkElement || target instanceof HTMLImageElement;
      if (isElementTarget) {
        // 资源加载出错相关的外理
        // var message = '静态资源加载失败 标签名:' + target.tagName + ' 资源地址:' + target.src;
        // apm.captureError(new Error(message));
      } else {
        // JS 异常的相关处理
        if (event.message == 'Script error.'
          || event.message == 'Script error'
          || event.message == 'Uncaught TypeError: parentEl.insertBefore is not a function'
          || event.message == 'Unhandled promise rejection: Error: Network Error'
          || event.message == `ReferenceError: Can't find variable: appBeforeGoBack`
          || event.message == `ResizeObserver loop limit exceeded`
          || event.message == `Uncaught TypeError: Cannot set property 'volume' of undefined`
          || event.message == `Uncaught TypeError: Cannot assign to read only property 'className' of object '#<SVGSVGElement>'`
        ) {
          return;
        }
        apm.captureError(event);
      }
      // console.log('error-event------->', event);
    }, true);
  }
}
</script>

<style>
@import "./common/css/template.less";
@import "./common/css/common.less";

body {
  -webkit-overflow-scrolling: touch;
}
li {
  list-style-type:none;
}
#app {
  height: 100%;
}

#appHeader {
  position: fixed;
  width: 100%;
  z-index: 10;
  left: 0;
  top: 0;
}

.single-line {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.lg_tbar_r {
  font-size: 14PX;
}

.scale-1px {
  position: relative;
  border: none;
}

.scale-1px:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  border: 1px solid #000;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 200%;
  height: 200%;
  -webkit-transform: scale(0.5);
  transform: scale(0.5);
  -webkit-transform-origin: left top;
  transform-origin: left top;
}

.clearfix:after {
  content: '';
  height: 0;
  display: block;
  clear: both;
}
</style>
